function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './meal-recipes-list.component.scss';
import template from './meal-recipes-list.html';
import { filterRecipeByTags } from "redesign/shared/helpers/filter-recipes-by-tags";

export var MealRecipesListComponent = {
  template: template,
  styles: styles,
  bindings: {
    recipesData: "<",
    search: "<",
    filteredTagsIds: "<",
    _onRecipeChoose: '&onRecipeChoose',
    _onWeekRecipeChoose: '&onWeekRecipeChoose' },

  controller: /*#__PURE__*/function () {MealRecipesListComponentController.$inject = ["$state", "FavoriteRecipeModel"];
    function MealRecipesListComponentController($state, FavoriteRecipeModel) {
      "ngInject";var _this = this;_classCallCheck(this, MealRecipesListComponentController);
      this.$state = $state;
      this.FavoriteRecipeModel = FavoriteRecipeModel;
      this.mealId = this.$state.params.mealId;
      this.categories = this.$state.params.categories;
      this.snack = this.$state.params.snack;
      this.week = this.$state.params.week;
      console.log(this);

      this.swiperOptoins = {
        centeredSlides: false,
        // slidesOffsetBefore: 23,
        // slidesOffsetAfter: 23,
        freeMode: true,
        preloadImages: false,
        lazy: true
        // breakpoints: {
        //   1199: {
        //     slidesOffsetBefore: 10,
        //     slidesOffsetAfter: 10,
        //   }
        // }
      };

      this.filterBy = function (recipe) {
        if (_this.search) {
          var search = _this.search.toLowerCase();
          if (!(recipe.name.toLowerCase().includes(search) || recipe.directions.toLowerCase().includes(search))) return false;
        }
        if (_this.filteredTagsIds.length) {
          var show = filterRecipeByTags(recipe, _this.filteredTagsIds);
          return show;
        } else
        return true;
      };

    }_createClass(MealRecipesListComponentController, [{ key: "$onInit", value: function $onInit()

      {var _this2 = this;
        this.FavoriteRecipeModel.query().then(function (favoriteRecipes) {
          _this2.favoriteRecipes = {};
          for (var i = 0; i < favoriteRecipes.length; i++) {
            _this2.favoriteRecipes[favoriteRecipes[i].recipe] = favoriteRecipes[i];
          }
        });
      } }, { key: "onRecipeChoose", value: function onRecipeChoose(

      recipe) {
        this._onRecipeChoose({ recipe: recipe });
      } }, { key: "onWeekRecipeChoose", value: function onWeekRecipeChoose(

      recipe) {
        this._onWeekRecipeChoose({ recipe: recipe });
      } }, { key: "favoriteIconClick", value: function favoriteIconClick(

      recipeId) {
        if (this.favoriteRecipes.hasOwnProperty(recipeId)) {
          this.removeFromFavorite(recipeId);
        } else
        {
          this.addToFavorite(recipeId);
        }
      } }, { key: "addToFavorite", value: function addToFavorite(

      recipeId) {var _this3 = this;
        var favoriteRecipe = new this.FavoriteRecipeModel({ recipe: recipeId });
        favoriteRecipe.$save().then(function (res) {
          _this3.favoriteRecipes[recipeId] = res;
        });
      } }, { key: "removeFromFavorite", value: function removeFromFavorite(

      recipeId) {
        this.favoriteRecipes[recipeId].$destroy();
        delete this.favoriteRecipes[recipeId];
      } }]);return MealRecipesListComponentController;}() };




if (module.hot) module.hot.accept('./meal-recipes-list.component.scss');